<template>
  <div class="tracking-normal normal-case">
    <modal name="modal-register" @opened="opened" :adaptive="true" :height="500" :width="400">
      <div class="px-10 py-8">
        <h2 class="mb-4 text-xl tracking-wide">{{ $t('nav.register') }}</h2>
        <form @submit.prevent="registerUser">
          <div class="mb-4 form-group">
            <label for="email" class="block mb-1 text-xs font-normal tracking-wide uppercase">{{ $t('modal.email') }}</label>
            <input v-model="email" ref="email" type="email" id="email" name="email" class="w-full px-4 py-2 bg-gray-200 border rounded" @keydown.shift.tab.prevent="">
          </div>
          <div class="mb-4 form-group">
            <label for="password" class="block mb-1 text-xs font-normal tracking-wide uppercase">{{ $t('modal.password') }}</label>
            <input v-model="password" type="password" id="password" name="password" class="w-full px-4 py-2 bg-gray-200 border rounded">
          </div>
          <div class="mb-8 form-group">
            <label for="confirm_password" class="block mb-1 text-xs font-normal tracking-wide uppercase">{{ $t('modal.passwordConfirm') }}</label>
            <input v-model="passwordConfirm" type="password" id="confirm_password" name="confirm_password" class="w-full px-4 py-2 bg-gray-200 border rounded">
          </div>
          <div class="mb-4 form-group">
            <button type="submit" class="w-full px-4 py-2 text-white rounded bg-live-orange hover:bg-live-blue">{{ $t('nav.register') }}</button>
          </div>
          <div v-if="error" class="py-2 text-sm font-normal text-center text-red-600">{{ error.message }}</div>
        </form>
        <div class="text-sm font-normal text-center">
          <p>{{ $t('modal.msgLogin') }} <a href="#" class="text-blue-600 hover:text-blue-800" @click.prevent="showLogin" @keydown.tab.exact.prevent="">{{ $t('nav.login') }}</a></p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
// Firebase
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      passwordConfirm: "",
      error: "",
      actionCodeSettings: {
        url: 'https://duwdev-firebase-auth.firebaseapp.com/',
        handleCodeInApp: true,
      }
    };
  },
  methods: {
    show() {
      this.$modal.show("modal-register")
    },
    showLogin() {
      this.$modal.show("modal-login")
      this.$modal.hide("modal-register")
    },
    opened() {
      this.$refs.email.focus()
    },
    hide() {
      this.$modal.hide("modal-register")
    },
    async registerUser() { 
      try {     
        await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
        this.$modal.hide("modal-register");
      } catch (error) {
        this.error = error;
        console.log(error);
      }
    }
  }
}
</script>